import API from '../../../constants/api';

export const FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC = '@@patientPortalEncounterSync/FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC';
export const FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC_SUCCESS = '@@patientPortalEncounterSync/FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC_SUCCESS';
export const FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC_FAILURE = '@@patientPortalEncounterSync/FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC_FAILURE';
export const RESET_PATIENT_PORTAL_ENCOUNTER_SYNC = '@@patientPortalEncounterSync/RESET_PATIENT_PORTAL_ENCOUNTER_SYNC';

export const fetchPatientPortalEncounterSync = ({
    page,
    size,
    filters,
    seekParams,
    seekDirection,
}) => ({
    type: FETCH_PATIENT_PORTAL_ENCOUNTER_SYNC,
    api: API.PATIENT_PORTAL_ENCOUNTER_SYNC.SEEKABLE_PAGE,
    page,
    size,
    filters,
    seekParams,
    seekDirection,
});

export const resetPatientPortalEncounterSync = () => ({
    type: RESET_PATIENT_PORTAL_ENCOUNTER_SYNC,
});
